import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { ButtonProps } from '../Button/Button';

export interface ButtonGroupProps {
  /** Multiple `<Button>` elements */
  children: ReactElement<ButtonProps>[];
  className?: string;
  id?: string;
  /**
   * Set to `true` to enable segmented button group styles.
   */
  segmented?: boolean;
}

/**
 * The ButtonGroup based on [The USWDS button group component](https://designsystem.digital.gov/components/button-groups/)
 *
 */
const ButtonGroup = ({ children, className, id, segmented = false }: ButtonGroupProps): JSX.Element => {
  const buttonGroupClasses = classNames(className, {
    'usa-button-group': true, // always on
    'usa-button-group--segmented': segmented,
  });

  return (
    <ul id={id} className={buttonGroupClasses}>
      {React.Children.map(children, (child) => (
        <li className="usa-button-group__item">{child}</li>
      ))}
    </ul>
  );
};

export default ButtonGroup;
